import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";

export interface IStatusList {
  id: string;
  value: string;
}
AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const usePaymentDebitStatusListAPI = () => {
  const configuration = useConfiguration();
  const [debitStatus, setDebitStatus] = useState<IStatusList[]>([]);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: ICartAPIResponse = await axios
        .get(`${PAYMENT_MODULE?.DEBIT_LIST_STATUS_API?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<any>) => {
          if (res.data.status === true) {
            setDebitStatus(res.data.data);

            return { status: true, message: "Cart Level Coupons Fetched" };
          } else {
            setDebitStatus([]);

            return { status: false, message: "No Cart Level Coupons" };
          }
        })
        .catch((e: AxiosError) => {
          setDebitStatus([]);
          sendCurl(e.config["curlCommand"]);
          captureError(e);

          return { status: false, message: "cart_not_filtered" };
        });
      return response;
    } catch (e: any) {
      setDebitStatus([]);

      captureError(e);
    }
  }, [dispatch]);
  return { debitStatus, execute };
};
